import * as loader from "../../../../components/file-loader/utils/utils";
import Toast from "../../../../components/modal/toast";

const createPreview = (tmp, url, onRemove) => {
  let preview = tmp.cloneNode(true);
  preview.querySelector("img").src = url;
  preview.querySelector("[data-close]").addEventListener("click", e => {
    onRemove();
  });
  return preview;
}

const initLoader = (form, name) => {
  let addFilesButton = form.querySelector('[data-add-files]');
  let previewContainer = form.querySelector('[data-previews]');
  let previewTmp = form.querySelector('[data-preview-tmp]');

  let checkCount = () => {
    let inputs = form.querySelectorAll(`[name="${name}"]`);
    if (inputs.length >= 2) {
      Toast.open("Не больше 2 изображений", { state: "error" });
      return false;
    }
    return true;
  }

  if (addFilesButton) {
    addFilesButton.addEventListener("click", () => {
      if (!checkCount()) {
        
        return;
      }
      loader.selectFiles({
        multiple: false,
        accept: loader.accepts.image,
      }).then(({files, input}) => {
        input.name = name;
        form.appendChild(input);

        loader.loadFile(files[0]).then(url => {
          let preview = createPreview(previewTmp, url, () => { 
            input.remove();
            preview.remove();
          });
          previewContainer.appendChild(preview);
        });
        
      });

    })
  }
}

export { initLoader };